<template>
  <MainMenu
    :isForcedOpen="isForcedOpen"
    :isMicrosite="microsite"
    :isShop="shop"
    :primaryLinks="primaryLinks"
    :secondaryLinks="secondaryLinks"
  />
</template>

<script>
import MainMenu from "../../components/MainMenu/MainMenu.vue";

export default {
  name: "app",
  components: {
    MainMenu
  },
  data() {
    return {
      isForcedOpen: this.$options._parentVnode.data.props.isForcedOpen,
      microsite: this.$options._parentVnode.data.props.microsite,
      shop: this.$options._parentVnode.data.props.shop,
      primaryLinks: JSON.parse(
        this.$options._parentVnode.data.props.primaryNav || "[]"
      ),
      secondaryLinks: JSON.parse(
        this.$options._parentVnode.data.props.secondaryNav || "[]"
      )
    };
  }
};
</script>
